export default __webpack_public_path__ + "static/media/home-icon-bottom-nav-mobile-active_b.8e536752.webp";